module.exports = __webpack_public_path__ + "static/WEDDING E&M-592-cc032d9492dc23aa5e0172c53efc8de4.jpg";